export default __webpack_public_path__ + "static/media/AreaChart.1b87ef43.svg";